export const COMMON_CONSTANTS = {
  docAPIConfig: {
    ncaFolderPath: 'Eclipse_NCA',
    ccFolderPath: 'Eclipse_CC',
    marsFolderPath: 'Eclipse_MARS',
    agreementFolderPath: 'Eclipse_Agreement',
    tpaFolderPath: 'Eclipse_TPA',
    guidanceInHeaderFolderPath: 'Eclipse-Guidance'
  },
  clientUseFulLinks: {
    ClientNEngagementSearch: "https://cps.deloitte.com/#/",
    ConflictSearchCCA: "https://cca.deloitte.com/ConflictCheck/External/Dashboard",
    DESC: "https://new-desc.com/admin/search/entity-search",
    KXResearchTools: "https://resources.deloitte.com/sites/kx/SitePages/KX-Research-Tools.aspx",
    DeloitteIQ: "https://iq.deloitte.com/",
    AdvantagedClientPortfolioList: "https://resources.deloitte.com/sites/US/CMG/ACP/Pages/AdvantagedClientPortfolio.aspx",
    Focus: "https://sfocus.deloitte.com/dashboard",
    Jupiter: "https://deloitte--s6.sandbox.lightning.force.com/lightning/page/home"
  },
  headerGuidanceDocument: {
    documentName: 'RelayQuickReferenceGuidance.pdf',
    documentGuid: '552eef70-f0df-4040-b0bd-812d22a9abda.pdf'
  },
  graphAPIConfig: {
    graphAPIURL: 'https://graph.microsoft.com/v1.0',
    searchOnlyNonUS: false,
    searchOnlyUS: true,
    GraphAPI_PeoplePicker_All: "NOT(country eq null)",
    GraphAPI_PeoplePicker_NonUS: "NOT(country eq 'United States') and NOT(country eq null)",
    GRAPHAPI_PeoplePicker_US: "(country eq 'United States') and endsWith(mail,'@deloitte.com')"
  }
};